import React from 'react';

import { translate } from '~l10n/client/translate';

interface SpecificStudentScoreCellProps {
  score: {
    currentScore: number;
    maxScore: number;
    isAbsent: boolean;
    percentage?: number;
  };
}

export const SpecificStudentScoreCell = (
  props: SpecificStudentScoreCellProps
) => {
  const { currentScore, maxScore, isAbsent, percentage } = props.score;

  if (isAbsent) {
    return (
      <div
        tabIndex={0}
        className="w-32 h-12 rounded-1 relative justify-center px-2 py-3 bg-grey-50 text-sm text-green-900 overflow-hidden focus:outline-none focus:ring-2 focus:ring-blue-500"
        aria-label={translate('Absent')}
      >
        {translate('Absent')}
      </div>
    );
  }

  const scoreText = translate('{0} of {1}').format(currentScore, maxScore);

  return (
    <div
      tabIndex={0}
      className="w-32 h-12 rounded-1 relative justify-center px-2 py-3 bg-green-50 text-sm text-green-900 overflow-hidden focus:outline-none focus:ring-2 focus:ring-blue-500"
      aria-label={scoreText}
    >
      <div
        className="absolute inset-0 bg-green-200 origin-left"
        style={{ transform: `scaleX(${percentage ?? 0})` }}
        aria-hidden="true"
      />
      <span className="relative">{scoreText}</span>
    </div>
  );
};
